// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__CiYNb","content":"LayoutSettings_content__2PwRj"};